// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3rqZr","content":"styles_content__3xVmk","checkbox":"styles_checkbox__2zW7n","checkboxLabel":"styles_checkboxLabel__2-KkJ"};